var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{},[_c('el-tag',{staticClass:"item-axis",attrs:{"size":"small","closable":""},on:{"close":_vm.removeItem}},[_vm._v("\n    "+_vm._s(_vm.item.name)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }